<nav class="navbar navbar-expand" [class.is-small]="isSmallDevice" [class.simulation]="user.simulated">
  <div class="collapse navbar-collapse" id="navbarText">
    <ul class="navbar-nav">
      <li class="nav-item menu-toggle-item">
        <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon menu-toggle" (click)="toggleMenu()"
          [attr.aria-expanded]="isMenuVisible" [attr.aria-label]="menuToggleLabel" [ngbTooltip]="menuToggleLabel"
          placement="bottom" data-testid="menu-toggle">
          <i class="fa fa-bars"></i>
        </button>
      </li>

      <li class="user-information">
        <div class="identity">
          <!-- Em tela pequena não existe logo na barra lateral, então a versão
               corrente aparece aqui; o switch em si vive no dropdown. -->
          <div class="version-chip" *ngIf="isSmallDevice && canSwitchVersion" data-testid="header-version-chip">
            <img [src]="versionIcon" [alt]="versionName" />
            <span>{{ versionName }}</span>
          </div>

          <div class="user-info" data-testid="component-user-simulated">
            <!-- A saudação é da conta (o dono); o membro ganha o selo ao lado.
                 Quem logou aparece no card do dropdown. -->
            <p class="greeting">Olá, {{ user.name }}</p>
            <p class="email">({{ user.email }})</p>
            <p class="member-badge" *ngIf="isMember" data-testid="header-greeting-member">Membro</p>
            <p class="simulating" *ngIf="user.simulated" data-testid="component-user-simulate-on">
              Simulando usuário
            </p>
          </div>

          <button *ngIf="user.simulated" type="button" class="sf-btn sf-btn--sm btn-back-user" (click)="backToLoggedInUser()"
            data-testid="btn-back-user-logged">
            <i class="fa fa-arrow-left"></i>
            {{ isSmallDevice ? "" : "Voltar para usuário logado!" }}
          </button>
        </div>
      </li>

      <li class="nav-item">
        <button type="button" class="sf-btn sf-btn--sm btn-header btn-header-warm call4u-animation"
          ngbTooltip="Ative mensagens de voz: clique aqui e saiba mais" placement="left" (click)="openPopup()"
          *ngIf="!usedCall4U" data-testid="btn-active-call4u">
          <i class="fa fa-phone"></i>
          {{ isSmallDevice ? "" : "Ative mensagens de voz" }}
        </button>
      </li>

      <li class="nav-item">
        <button type="button" class="sf-btn sf-btn--sm sf-btn--secondary btn-header" ngbTooltip="Programa de afiliados: clique aqui e saiba mais"
          placement="left" routerLink="/affiliates" *ngIf="(isClient && isAffiliate) || isAdministrator"
          data-testid="btn-affiliates">
          <i class="fa fa-bullhorn"></i>
          {{ isSmallDevice ? "" : "Programa de Afiliados" }}
        </button>
      </li>

      <li class="nav-item icon-group">
        <!-- Pílula de escopo (CU-86akn0zp6): no desktop, à esquerda do avatar.
             Verde da marca no nacional e azul (`--sms-intl-accent`) no
             internacional: desde 28/09/2026 ela é o único elemento que muda de
             cor entre as versões. Em tela pequena quem indica a versão continua
             sendo o `version-chip`, que fica junto do nome. -->
        <button type="button" class="scope-pill" *ngIf="canSwitchVersion && !isSmallDevice"
          [class.scope-pill--international]="isInternational" [ngbTooltip]="scopeTooltip" placement="bottom"
          (click)="toggleAccountVersion()" data-testid="header-scope-pill">
          <img [src]="versionIcon" [alt]="versionName" />
          <span>{{ scopeLabel }}</span>
        </button>

        <div class="header-icon notification" (click)="toggleNotifications(true)" (mouseover)="stopCloseNotifications()"
          (mouseout)="toggleNotifications()" data-testid="btn-notification">
          <i class="fa fa-2x fa-bell-o"></i>
          <span class="badge">{{ notifications.length }}</span>

          <div class="notification-items" [style]="{ display: showNotifications ? 'flex' : 'none' }">
            <h2 data-testid="h2-modal-notification">
              Avisos
              <i class="counter" *ngIf="selectedNotifications.length > 0">{{
                selectedNotifications.length
                }}</i>
              <i class="fa fa-check-square-o" ngbTooltip="Marcar todas como lida" placement="bottom-left"
                (click)="markAllRead()"></i>
              <i class="fa fa-ellipsis-v" *ngIf="selectedNotifications.length > 0"></i>
            </h2>
            <div class="container">
              <div class="notification-item" [class.fa-bold]="notification.read"
                *ngFor="let notification of sortedNotifications">
                <i class="fa fa-bell-o notification-item__icon"></i>
                <div class="notification-item__body">
                  <p>{{ notification.message }}</p>
                  <label>{{ notificationDateLabel(notification.created_at) }}</label>
                </div>
                <i class="fa fa-check" ngbTooltip="Marcar como lida" placement="top-right"
                  (click)="markAsRead(notification)"></i>
              </div>
            </div>
            <div class="notification-item no-alert" *ngIf="notifications.length === 0">
              Você não tem nenhuma notificação =)
            </div>
          </div>
        </div>

        <!-- Carteira: ícone próprio ao lado do avatar. O badge só acende depois
             que uma abertura revelou saldo negativo — o header não consulta. -->
        <div class="header-icon wallet" [ngbTooltip]="walletTooltip" (click)="openWalletModal()"
          data-testid="btn-wallet">
          <i class="fa fa-2x fa-credit-card"></i>
          <span class="badge overdraft" *ngIf="hasWalletOverdraft" data-testid="wallet-overdraft-badge">!</span>
        </div>

        <div class="dropdown">
          <div class="icons" data-testid="profile-options">
            <div class="icon" (click)="toggleDropdown()" (mouseout)="startCloseTime()" (mouseover)="stopCloseTime()">
              <img src="/assets/user-photo.png" alt="" />
              <span>
                <i class="fa fa-angle-down"></i>
              </span>
            </div>
          </div>

          <div class="dropdown-menu" [class.show]="showDropdown" (mouseout)="startCloseTime()"
            (mouseover)="stopCloseTime()" aria-labelledby="navbarDropdownMenuLink">
            <!-- Multiusuários (CU-17tm466h1cm): quem está logado e o papel dele
                 na conta. Só aparece quando o recurso vale para a conta. -->
            <div class="dropdown-identity" *ngIf="showsMultiuser || isMember" data-testid="header-identity">
              <span class="identity-name">{{ displayName }}</span>
              <span class="identity-email">{{ displayEmail }}</span>
              <span class="identity-role" [class.identity-role--member]="isMember" data-testid="header-role">
                {{ isMember ? 'Membro' : 'Proprietário' }}
              </span>
            </div>

            <!-- O switch de versão só existe para quem tem acesso ao
                 internacional (`intl_enabled`, vindo do backend). -->
            <a *ngIf="canSwitchVersion" class="dropdown-item dropdown-item-version" role="button"
              (click)="toggleAccountVersion()" (mouseout)="startCloseTime()" (mouseover)="stopCloseTime()"
              data-testid="toggle-account-version">
              <img [src]="switchVersionIcon" [alt]="switchVersionLabel" />
              {{ switchVersionLabel }}
            </a>

            <a class="dropdown-item" routerLink="/change-password" (mouseout)="startCloseTime()"
              (mouseover)="stopCloseTime()" data-testid="change-password-router">
              <i class="fa fa-key"></i>
              Alterar senha
            </a>
            <a class="dropdown-item" routerLink="/profile" (mouseout)="startCloseTime()" (mouseover)="stopCloseTime()"
              data-testid="change-profile-router">
              <i class="fa fa-user"></i>
              Meus dados
            </a>

            <a *ngIf="showsMultiuser" class="dropdown-item dropdown-item-members" role="button"
              (click)="openMembersModal()" (mouseout)="startCloseTime()" (mouseover)="stopCloseTime()"
              data-testid="header-members">
              <i class="fa fa-users"></i>
              Multiusuários
              <span class="members-count" data-testid="header-members-count">{{ membersCountLabel }}</span>
            </a>

            <!-- Token da API é do proprietário (`owner_only` no backend). -->
            <a *ngIf="user.api_enabled && !isMember" class="dropdown-item" routerLink="/profile/api" (mouseout)="startCloseTime()"
              (mouseover)="stopCloseTime()">
              <i class="fa fa-cloud"></i>
              API
            </a>

            <a class="dropdown-item" routerLink="/" (click)="logout()" (mouseout)="startCloseTime()"
              (mouseover)="stopCloseTime()" data-testid="logout-btn">
              <i class="fa fa-power-off"></i>
              Sair
            </a>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <app-account-members-modal [showModal]="showMembersModal"
    (overviewLoaded)="onMembersOverviewLoaded($event)"
    (overviewStale)="onMembersOverviewStale()"></app-account-members-modal>
  <app-wallet-modal [showModal]="showWalletModal"
    (balanceLoaded)="onWalletBalanceLoaded($event)"></app-wallet-modal>
</nav>

<call4u-activate-popup *ngIf="togglePopUp" [onClose]="closeCall4U"></call4u-activate-popup>
